import { render, staticRenderFns } from "./Fork.vue?vue&type=template&id=cc7dc800&scoped=true&"
import script from "./Fork.vue?vue&type=script&lang=js&"
export * from "./Fork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc7dc800",
  null
  
)

export default component.exports